if (!customElements.get('dbg-product-carousel')) {
  class DbgProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dbg-pr__track');
      this.previousButton = this.querySelector('.dbg-pr__arrow--prev');
      this.nextButton = this.querySelector('.dbg-pr__arrow--next');

      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.previousButton.addEventListener('click', () => this.move(-1));
      this.nextButton.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.update(), { passive: true });
      }

      requestAnimationFrame(() => this.update());
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    move(direction) {
      const firstCard = this.track.querySelector('.dbg-pr__book');
      if (!firstCard) return;

      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      const step = firstCard.getBoundingClientRect().width + gap;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({
        left: direction * step,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }

    queueUpdate() {
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.update());
    }

    update() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const hasOverflow = maximum > 4;
      this.previousButton.hidden = !hasOverflow;
      this.nextButton.hidden = !hasOverflow;
      this.previousButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maximum - 4;
    }
  }

  customElements.define('dbg-product-carousel', DbgProductCarousel);
}
